/**
 * Check if options array consists of grouped options,
 * If at least one option doesn't have a group it's considered to be flat
 */
function isGrouped(options) {
  return options.length > 0 && options.every(option => 'options' in option);
}
/**
 * Checks if selectedOptions are present in the options array
 */
function isSelected(option, selectedOptions) {
  return selectedOptions.some(selectedOption => selectedOption.value === option.value);
}
function isFocused(option, focusedOption) {
  return option.value && option.value === (focusedOption === null || focusedOption === void 0 ? void 0 : focusedOption.value);
}
/**
 * Creates a unique "cheap" hash for an options array.
 * Utilizes required properties, like value, title and group name.
 */
function optionsHash(options) {
  // Uses ASCII unit separators to avoid accidental collisions in text fields.
  const P = '\x1F'; // option property divider
  const G = '\x1E'; // option group divider
  const O = '\x1D'; // option item header
  // Grouped options hash is constructed differently from the flat one
  if (isGrouped(options)) {
    return 'g' + O + options.map(g => g.group + G + g.options.map(o => {
      var _a;
      return o.value + P + o.title + P + ((_a = o.subtitle) !== null && _a !== void 0 ? _a : '');
    }).join(G)).join(O);
  }
  // flat
  return 'f' + O + options.map(o => {
    var _a;
    return o.value + P + o.title + P + ((_a = o.subtitle) !== null && _a !== void 0 ? _a : '');
  }).join(O);
}

export { isFocused, isGrouped, isSelected, optionsHash };
